import api from "../../Services/api";
import React, { useEffect, useState } from "react";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import { useNavigate } from "react-router-dom";
import GridRegistros from "../../Componentes/GridRegistros";
import Swal from "sweetalert2";
import Modal from 'react-modal';
import "./index.css";

const CadastroCargo = () => {
  const [descricao, setDescricao] = useState("");
  const [permissoes, setPermissoes] = useState([]);
  const [permissaoSelecionada, setPermissaoSelecionada] = useState(null);

  const { authReady } = useAuthContext();
  const { IDOperador, nome, operador } = useOperador();

  const [cargos, setCargos] = useState([]);

  const [modalAberto, setModalAberto] = useState(false);
  const [idCargoEditando, setIdCargoEditando] = useState(null);

  const navigate = useNavigate();

  let idFormatado = String(IDOperador).padStart(6, '0');

  useEffect(function () {
    //console.log('OPERADOR', user);
    if (!operador && !authReady) {
      navigate("/");
    }
  }, [operador]);

  useEffect(() => {
    carregarPermissoes();
    carregarCargos();
  }, []);

  const carregarCargos = async () => {
    try {
      const res = await api.get("/cargos");
      setCargos(res.data);
    } catch (err) {
      console.error("Erro ao carregar cargos", err);
    }
  };

  const exibirErrosValidacao = (err, titulo = "Erro") => {
    const bodyErrors = err.response?.data?.erros?.body;

    if (bodyErrors) {
      const mensagens = Object.entries(bodyErrors)
        .map(([campo, msg]) => `<b>${campo}</b>: ${msg}`)
        .join("<br>");

      Swal.fire({
        title: titulo,
        html: mensagens,
        icon: "error"
      });
    } else {
      Swal.fire(titulo, "Erro inesperado ao processar requisição.", "error");
    }
  };

  const carregarPermissoes = async () => {
    try {
      const res = await api.get("/permissoes");
      setPermissoes(res.data);
    } catch (err) {
      console.error("Erro ao carregar cargos", err);
    }
  };

  const SalvarCargo = async () => {
    if (!descricao || !permissaoSelecionada) {
      alert("Preencha todos os campos.");
      return;
    }

    try {
      // Primeiro insert: salva o cargo
      const resCargo = await api.post("/cargo", { descricao });

      if (resCargo.status === 201 && resCargo.data.IDCargo) {
        const IDCargo = resCargo.data.IDCargo;

        // Segundo insert: vincula a permissão ao cargo
        const resPermissao = await api.post("/cargopermissao", {
          IDCargo,
          IDPermissao: permissaoSelecionada,
        });

        if (resPermissao.status === 201) {
          alert("Cargo e permissão cadastrados com sucesso!");
          setDescricao("");
          setPermissaoSelecionada(null);
          await carregarCargos();
        } else {
          alert("Erro ao vincular permissão.");
        }
      } else {
        console.log(resCargo);
        alert("Erro ao salvar cargo.");
      }
    } catch (err) {
      console.error(err);
      exibirErrosValidacao(err, "Erro");
    }
  };

  const handleEdit = (registro) => {
    setDescricao(registro.descricao);
    abrirModalEditar(registro);
  };

  const handleDelete = async (id) => {
    try {
      console.log('ID: ' + id)
      const res = await api.delete(`/cargo/${id}`);
      if (res.status === 204) {
        alert("Registro excluído com sucesso!");
        carregarCargos();
      } else {
        console.log(res);
        alert("Erro ao excluir.");
      }
    } catch (err) {
      console.log(err);
      exibirErrosValidacao(err, "Erro");
    }
  };

  const abrirModalNovo = () => {
    setDescricao("");
    setPermissaoSelecionada(null);
    setIdCargoEditando(null);
    setModalAberto(true);
  };

  const abrirModalEditar = (registro) => {
    setDescricao(registro.descricao);
    setPermissaoSelecionada(registro.IDPermissao); // se você salvar isso no grid
    setIdCargoEditando(registro.IDCargo);
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
  };


  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nome} />
        <h4 style={{ width: '100%', textAlign: 'center', paddingTop: '50px' }}>CARGOS</h4>

        <div className="container">
          <div className="form-group">
            <label>Descrição do Cargo</label>
            <input
              type="text"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              placeholder="Digite a descrição do cargo"
            />
          </div>

          <div className="form-group">
            <label>Permissão</label>
            <div className="radio-group">
              {permissoes.map((perm) => (
                <label
                  key={perm.IDPermissao}
                  className={`radio-option ${permissaoSelecionada === perm.IDPermissao ? "selected" : ""
                    }`}
                >
                  <input
                    type="radio"
                    name="permissao"
                    value={perm.IDPermissao}
                    checked={permissaoSelecionada === perm.IDPermissao}
                    onChange={() => setPermissaoSelecionada(perm.IDPermissao)}
                  />
                  {perm.descricao}
                </label>
              ))}
            </div>
          </div>

          <button onClick={SalvarCargo}>Salvar Cargo</button>
        </div>

        <br />
        <div>
          <GridRegistros
            registros={cargos}
            onEdit={handleEdit}
            onDelete={handleDelete}
            chaveId="IDCargo"
            exibirEditar={false}
            ocultarCampos={["IDCargo_permissao"]}
          />
        </div>
      </div>
    </div>

  );
};

export default CadastroCargo;
